export default () => (
  /**
   * Ícone "X", geralmente utilizado no fechamento de janelas
   */
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      y1="-0.75"
      x2="14"
      y2="-0.75"
      transform="matrix(-0.707107 0.707107 0.707107 0.707107 11.3147 1.43506)"
      stroke="black"
      strokeOpacity="0.6"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="14"
      y2="-0.75"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.41492 0.135986)"
      stroke="black"
      strokeOpacity="0.6"
      strokeWidth="1.5"
    />
  </svg>
);
